import { FormGroup } from "react-bootstrap";
import styled from 'styled-components';
export const StyledFormGroup = styled(FormGroup)`

.form-control {
  border-radius: 0 !important;
}

.styled__control-is-focused {
  box-shadow: none !important;
}

.form-control:focus {
  outline: 0;
  -webkit-box-shadow: none !important;
    -moz-box-shadow: none !important;
    box-shadow: none !important;
}

.form-control {
  border: 1px solid var(--grey-20, #C9CBCF);
  border-radius: 0;
  height: 50px;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  outline: none;

  &.has-error {
    border-color: var(--red-50, #FC2C03);
  }

  ::-webkit-input-placeholder {
    font-family: "Montserrat Regular";
    font-size: 14px;
      color: var(--grey-30, #AFB2B6) !important;

  }

  ::-moz-placeholder {
    font-family: "Montserrat Regular";
    font-size: 18px;
      color: var(--grey-30, #AFB2B6) !important;

  }

  :-ms-input-placeholder {
    font-family: "Montserrat Regular";
    font-size: 18px;
      color: var(--grey-30, #AFB2B6) !important;

  }

  :-moz-placeholder {
    font-family: "Montserrat Regular";
    font-size: 18px;
      color: var(--grey-30, #AFB2B6) !important;

  }
}

.form-control::placeholder {
  opacity: 0.45 !important;
  color: var(--grey-30, #AFB2B6) !important;
  font-family: "Montserrat Regular" !important;
  font-size: 14px !important;
  letter-spacing: 0 !important;
}

`